module.exports = __webpack_public_path__ + "img/edit.083a183e.svg";